var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drug-siderbar"},[_c('van-sidebar',{on:{"change":_vm.handleChange},model:{value:(_vm.activeId),callback:function ($$v) {_vm.activeId=$$v},expression:"activeId"}},_vm._l((_vm.category),function(item,key){return _c('van-sidebar-item',{key:key,attrs:{"title":item.name}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }